export default function IconCheckCircle(props: Icon) {
  const { height, width, className } = props;
  return (
    <svg
      className={`icon-unchecked flex-shrink-0${
        className ? ` ${className}` : ""
      }`}
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 800 800"
    >
      <path
        fill="currentColor"
        d="M480-80q-83,0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83,31.5-156T197-763q54-54,127-85.5T480-880q83,0,156,31.5T763-763q54,54,85.5,127T880-480q0,83-31.5,156T763-197q-54,54-127,85.5T480-80Zm0-80q134,0,227-93t93-227q0-134-93-227T480-800q-134,0-227,93T160-480q0,134,93,227T480-160Z"
        transform="translate(-80 880)"
      />
    </svg>
  );
}
